import { render, staticRenderFns } from "./TeamShield.vue?vue&type=template&id=44dc4066"
import script from "./TeamShield.vue?vue&type=script&lang=js"
export * from "./TeamShield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports